const {
  blockEditor: { InnerBlocks, useBlockProps },
} = wp;

const Save = () => {
  const blockProps = useBlockProps.save();
  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
